export default {
  "adminSignIn": "Admin Sign In",
  "and": "and",
  "asMeasuredIn": "as measured in",
  "authPin": "Authenticate PIN",
  "battery": "battery",
  "charactersRemaining": "Characters Remaining",
  "checkEmail": "Check Your Email",
  "checkEmailPin": "Check your email for a 5-digit PIN number to sign in.",
  "checkYourEmailForSpecialLink": "Check your email for a special link that will allow you to sign in to your account without having to remember a password!",
  "closeDialog": "Close Dialog",
  "closeDialogWindow": "Close Dialog Window",
  "computeCapacityLineOne": "Reducing carbon output with",
  "computeCapacityLineTwo": "compute capacity.",
  "email": "Email Address",
  "enterCode": "Enter Code",
  "enterEmail": "Enter your email address",
  "enterFirstName": "Enter First Name",
  "enterLastName": "Enter Last Name",
  "enterPassword": "Enter your password",
  "enterPin": "Enter PIN",
  "errorLoggingIn": "Error Logging In",
  "errorSendingLink": "Error Sending Link",
  "errorSendingLinkMessage": "There was an error sending you a Magic Link. Please, enter your email in the following page.",
  "ev": "EV",
  "evse": "electric vehicle service equipment",
  "expiredLinkMessage": "It looks like you tried to login with an expired link. Submit your email address, again, to have a new link sent.",
  "exportCsvFile": "Export CSV File",
  "failedLogin": "Your login attempt failed.",
  "filters": "Filters",
  "firstName": "First Name",
  "forgotPassword": "Forgot password?",
  "from": "from",
  "graphDescription": "Graph Description",
  "here": "here",
  "hoSignIn": "Homeowner Sign In",
  "hwh": "hot water heater",
  "ifYouNeedHelpPleaseClick": "If you need help, please click",
  "incorrectEmailOrPassword": "You have tried to log in with an incorrect email address and/or password.",
  "itPlots": "It plots",
  "justNeedAFewDetails": "Just need a few details to get your account ready to go.",
  "lastName": "Last Name",
  "kW": "kilowatts",
  "kwh": "kilowatt hours",
  "loading": "Loading",
  "lockedOut": "You have been locked out because of too many failed attempts. You can try again in 15 minutes.",
  "loginErrorMessage": "There was an error when you were trying to log in. If you need help, please contact us at {supportEmail}.",
  "loginInFirstTime": "If this is your first time logging in, please use the Secure Link login.",
  "logout": "Logout",
  "magicLink": "The magic link should arrive in your email inbox shortly. You can close this browser window now.",
  "noData": "No Data",
  "noResults": "No Results",
  "off": "Off",
  "on": "On",
  "orContactUsAt": "or contact us at",
  "overTime": "over time",
  "password": "Password",
  "rac": "room air conditioning",
  "resetPassword": "Reset Password",
  "resetPasswordMessage": "Please enter your email address, and we will send you a link to reset your password. For additional help, email ",
  "result": "Result",
  "results": "Results",
  "signIn": "Sign In",
  "signInLink": "Sign in with a special link sent to the email address entered below.",
  "s": "seconds",
  "search": "Search",
  "seconds": "seconds",
  "sendPin": "Send me a PIN",
  "sendSecureLink": "Send Secure Link",
  "setupAccount": "Setup Account",
  "show": "Show",
  "sign": "Sign",
  "signInEmailAndPassword": "Sign in with your email address and password.",
  "signInPassword": "Sign in with a password",
  "smartGrid": "Improving the IQ of the Smart Grid...",
  "theCapacityOfYour": "the capacity of your",
  "theEnergyConsumptionOfYour": "the energy consumption of your",
  "theModeSetOnYour": "the mode set on your",
  "thePowerConsumedByYour": "the power consumed by your",
  "theTemperatureAtYour": "the temperature at your",
  "thereWasAnErrorLoggingIn": "There was an error when you were trying to log in.",
  "thisGraphShows": "This graph shows",
  "time": 'Time',
  "toATime": "to",
  "tryAgain": "Try Again",
  "tstat": "thermostat",
  "twoFactorAuth": "Two Factor Authentication",
  "usePassword": "Use Password",
  "useSecureLink": "Use Secure Link",
  "utilitySignIn": "Utility Sign In",
  "verify": "Verify",
  "verifyIdentityMessage": "Verify your identity by entering the 6 digit code from the authenticator app on your device.",
  "youAreAllSet": "You are all set!",
  "gravitySignIn": "Developer Sign In",
};
